import { serviceRequest } from 'utils/http';
import { SiteEmployeeSelfUpdateDto, SiteEmployeeService } from 'common/api';

export function updateCurrentSiteEmployeeAPI(
  requestBody: SiteEmployeeSelfUpdateDto
) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerUpdateCurrentSiteEmployee(
      requestBody
    )
  );
}
